/* Toleel theme — light interactions (no framework) */
(function () {
  "use strict";

  /* Mega-nav: open panel on hover (desktop), toggle on click (touch).
     Panels render outside the nav row now, so query them at document scope
     and use a small close delay so moving from the row into the panel keeps it open. */
  var nav = document.getElementById("megaNav");
  if (nav) {
    var items = nav.querySelectorAll(".mega-item.has-panel");
    var closeTimer;
    function closeAll() {
      document.querySelectorAll(".mega-panel.open").forEach(function (p) { p.classList.remove("open"); });
    }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(closeAll, 180); }
    function cancelClose() { clearTimeout(closeTimer); }
    items.forEach(function (it) {
      var panel = document.querySelector('.mega-panel[data-mi="' + it.dataset.mi + '"]');
      if (!panel) return;
      it.addEventListener("mouseenter", function () { cancelClose(); closeAll(); panel.classList.add("open"); });
      it.addEventListener("mouseleave", scheduleClose);
      it.addEventListener("click", function (e) {
        if (e.target.closest("a") && e.target.closest("a").getAttribute("href") !== "#") return;
        e.preventDefault();
        var open = panel.classList.contains("open");
        closeAll();
        if (!open) panel.classList.add("open");
      });
      panel.addEventListener("mouseenter", cancelClose);
      panel.addEventListener("mouseleave", scheduleClose);
    });
  }

  /* Add-to-cart from a product card: post via fetch so the page doesn't reload */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".card-form");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector("button");
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) { form.submit(); return; }
    var original = btn.innerHTML;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: idInput.value, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch("/cart.js"); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        btn.innerHTML = "✓ Added";
        toast("Added to cart");
        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400);
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = original; form.submit(); });
  });

  function toast(msg) {
    var wrap = document.querySelector(".toast-wrap");
    if (!wrap) { wrap = document.createElement("div"); wrap.className = "toast-wrap"; document.body.appendChild(wrap); }
    var t = document.createElement("div");
    t.className = "toast";
    t.textContent = msg;
    wrap.appendChild(t);
    setTimeout(function () { t.style.opacity = "0"; t.style.transform = "translateY(10px)"; setTimeout(function () { t.remove(); }, 300); }, 2400);
  }
})();
